module.exports = __webpack_public_path__ + "img/sol_cap2.6b8fd482.png";